import { motion } from 'framer-motion';

const LIGHTS_COUNT = 9;

export default () => {
    return (
        <div className="semi-wheel-lights">
            {Array.from({ length: LIGHTS_COUNT }).map((_, index) => {
                const firstGroup = index % 2 === 0;

                return (
                    <div className="light-sector" key={index}>
                        <motion.div
                            className="light"
                            animate={{
                                opacity: firstGroup
                                    ? [0.15, 1, 1, 0.15]
                                    : [1, 0.15, 0.15, 1],
                                scale: firstGroup
                                    ? [1, 1.08, 1.08, 1]
                                    : [1.08, 1, 1, 1.08],
                            }}
                            transition={{
                                duration: 1.2,
                                repeat: Infinity,
                                ease: 'easeInOut',
                                times: [0, 0.3, 0.7, 1],
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
};